import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import "./App.css";
import "../src/Component/Modal/Modal.css";
import Home from "../src/View/Home/Index";
import Login from "./Athentication/Login";

import MainLayout from "./Layout/MainLayout";
import Privateroute from "./PrivateRoute/Privateroute";
// import AddCity from "./View/Pages/City/addCity";
// import ManageCity from "./View/Pages/City/ManageCity";
// import AddPropertyType from "./View/Pages/PropertyType/AddPropertyType";
// import ManagePropertyType from "./View/Pages/PropertyType/ManagePropertyType";
// import AddBhk from "./View/Pages/BHK/AddBhk";
// import ManageBhk from "./View/Pages/BHK/ManageBhk";
// import AddFloor from "./View/Pages/Floor/AddFloor";
// import ManageFloor from "./View/Pages/Floor/ManageFloor";
// import AddProperty from "./View/Pages/Property/AddProperty";
// import ManageProperty from "./View/Pages/Property/ManageProperty";
// import AddSubscription from "./View/Pages/Subscription/AddSubscription";
// import ManageSubscription from "./View/Pages/Subscription/ManageSubscription";
// import AddBanner from "./View/Pages/Banner/AddBanner";
// import AddAdvertisement from "./View/Pages/Advertisement/AddAdvertisement";
// import ManageAdvertisement from "./View/Pages/Advertisement/ManageAdvertisement";
// import AddFacing from "./View/Pages/Facing/AddFacing";
// import ManageFacing from "./View/Pages/Facing/ManageFacing";
// import AddDesignation from "./View/Pages/Designation/AddDesignation";
// import ManageDesignation from "./View/Pages/Designation/ManageDesignation";
// import AddStaff from "./View/Pages/Staff/AddStaff";
// import ManageStaff from "./View/Pages/Staff/ManageStaff";
// import AddLocality from "./View/Pages/Locality/AddLocality";
// import ManageLocality from "./View/Pages/Locality/ManageLocality";
// import AddUser from "./View/Pages/User/AddUser";
// import ManageUser from "./View/Pages/User/ManageUser";
// import AddSociety from "./View/Pages/Society/AddSociety";
// import AddCommunity from "./View/Pages/Community/AddCommunity";
// import AddInventory from "./View/Pages/Inventory/AddInventory";
// import ManageSociety from "./View/Pages/Society/ManageSociety";
// import ManageCommunity from "./View/Pages/Community/ManageCommunity";
// import ManageInventory from "./View/Pages/Inventory/ManageInventory";
// import Sales from "./View/Pages/Sales/Sales.jsx";
// import AddApartment from "./View/Pages/Apartment/AddApartment.jsx";
// import AddCommission from "./View/Pages/Commission/AddCommission.jsx";
// import AddRent from "./View/Pages/Rent/AddRent.jsx";
// import AddElectricity from "./View/Pages/Electricity/AddElectricity.jsx";
// import AddTelephoneInternet from "./View/Pages/TelephoneInternet/AddTelephoneInternet.jsx";
// import AddPetrol from "./View/Pages/Petrol/AddPetrol.jsx";
// import AddMiscellaneous from "./View/Pages/Miscellaneous/AddMiscellaneous.jsx";
// import ManageCommission from "./View/Pages/Commission/ManageCommission.jsx";
// import ManageRent from "./View/Pages/Rent/ManageRent.jsx";
// import ManageElectricity from "./View/Pages/Electricity/ManageElectricity.jsx";
// import ManageTelephoneInternet from "./View/Pages/TelephoneInternet/ManageTelephoneInternet.jsx";
// import ManagePetrol from "./View/Pages/Petrol/ManagePetrol.jsx";
// import ManageMiscellaneous from "./View/Pages/Miscellaneous/ManageMiscellaneous.jsx";
// import ManageApartment from "./View/Pages/Apartment/ManageApartment.jsx";
// import ExpenseReport from "./View/Pages/Report/ExpenseReport.jsx";
// import EmailToStaff from "./View/Pages/SendEmail/EmailToStaff.jsx";
// import HotClientList from "./View/Pages/HotClients/HotClientList.jsx";
// import AddSalesPipeline from "./View/Pages/SalesPipeline/AddSalesPipeline.jsx";
// import ManageSalesPipeline from "./View/Pages/SalesPipeline/ManageSalesPipeline.jsx";
// import SentEmailsToStaff from "./View/Pages/SendEmail/SentEmailsToStaff.jsx";
// import AddMenuAccess from "./View/Pages/MenuAccess/AddMenuAccess.jsx";
// import AddSalary from "./View/Pages/Salary/AddSalary.jsx";
// import ManageSalary from "./View/Pages/Salary/ManageSalary.jsx";
// import Worksheet from "./View/Pages/Worksheet/Worksheet.jsx";
// import DynamicTable from "./View/Pages/RND/DynamicTable.jsx";
// import AddBlog from "./View/Pages/Blog/AddBlog.jsx";
// import ManageBlog from "./View/Pages/Blog/ManageBlog.jsx";
import ManageState from "./Pages/State/ManageState.jsx";
import ManageDistrict from "./Pages/District/ManageDistrict.jsx";
import ManageCity from "./../src/Pages/City/ManageCity.jsx";
import ManageUniversity from "./Pages/University/ManageUniversity.jsx";
import CourseCategory from "./Pages/CourseCategory/CourseCategory.jsx";
import ManageCourse from "./Pages/Course/ManageCourse.jsx";
import AddCollegeUniversity from "./Pages/College-University/AddCollegeUniversity.jsx";
import ManageCollegeUniversity from "./Pages/College-University/ManageCollegeUniversity.jsx";
import AddCourseAndFees from "./Pages/CourseAndFees/AddCourseAndFees.jsx";
import ManageCourseAndFees from "./Pages/CourseAndFees/ManageCourseAndFees.jsx";
import ManageCountry from "./Pages/Country/ManageCountry.jsx";
import CollegeUniversityOverview from "./Pages/College-University/CollegeUniversityOverview.jsx";
import CollegeUniversityCoursesFees from "./Pages/College-University/CollegeUniversityCoursesFees.jsx";
import CollegeUniversityAdmission from "./Pages/College-University/CollegeUniversityAdmission.jsx";
import AddScholarship from "./Pages/Scholarship/AddScholarship.jsx";
import ManageScholarship from "./Pages/Scholarship/ManageScholarship.jsx";
import CollegeUniversityScholarship from "./Pages/College-University/CollegeUniversityScholarship.jsx";
import CollegeUniversityPlacement from "./Pages/College-University/CollegeUniversityPlacement.jsx";
import AddBlog from "./Pages/Blog/AddBlog.jsx";
import ManageBlog from "./Pages/Blog/ManageBlog.jsx";
import ManageGallery from "./Pages/Gallery/ManageGallery.jsx";
import CollegeUniversityRanking from "./Pages/College-University/CollegeUniversityRanking.jsx";
import CollegeUniversityCampus from "./Pages/College-University/CollegeUniversityCampus.jsx";
import CollegeUniversityFees from "./Pages/College-University/CollegeUniversityFees.jsx";
import CollegeUniversityCutOffs from "./Pages/College-University/CollegeUniversityCutOffs.jsx";
import AddFacility from "./Pages/Facilities/AddFacility.jsx";
import ManageFacility from "./Pages/Facilities/ManageFacility.jsx";
import ManageAccredition from "./Pages/Accredition/ManageAccredition.jsx";
import ManageExam from "./Pages/Exam/ManageExam.jsx";
const App = () => {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route element={<Privateroute />}>
            <Route element={<MainLayout />}>
              <Route path="/" element={<Home />} />
              {/* <Route path="/" element={<ManageState />} /> */}

              {/* Users Route */}
              {/* <Route path="/manage-user" element={<ManageUser />} />
              <Route path="/manage-user-curior" element={<ManageCurior />} />
              <Route path="/manage-user-rights" element={<ManageUserRights />} /> */}

              {/* City Route */}
              {/* <Route path="/add-city" element={<AddCity />} /> */}
              <Route path="/manage-country" element={<ManageCountry />} />
              <Route path="/manage-state" element={<ManageState />} />
              {/* <Route path="/manage-city" element={<ManageCity />} /> */}
              <Route path="/manage-district" element={<ManageDistrict />} />
              <Route path="/manage-city" element={<ManageCity />} />
              <Route path="/manage-university" element={<ManageUniversity />} />
              <Route
                path="/manage-accredition"
                element={<ManageAccredition />}
              />
              <Route path="/manage-exam" element={<ManageExam />} />
              <Route
                path="/manage-course-category"
                element={<CourseCategory />}
              />
              <Route path="/manage-course-name" element={<ManageCourse />} />
              <Route
                path="/add-college-university"
                element={<AddCollegeUniversity />}
              />
              <Route
                path="/college-university-overview"
                element={<CollegeUniversityOverview />}
              />

              <Route
                path="/college-university-coursesfees"
                element={<CollegeUniversityCoursesFees />}
              />

              <Route
                path="/college-university-admission"
                element={<CollegeUniversityAdmission />}
              />

              <Route
                path="/college-university-scholarship"
                element={<CollegeUniversityScholarship />}
              />

              <Route
                path="/college-university-placement"
                element={<CollegeUniversityPlacement />}
              />

              <Route
                path="/college-university-cutoffs"
                element={<CollegeUniversityCutOffs />}
              />

              <Route
                path="/college-university-ranking"
                element={<CollegeUniversityRanking />}
              />

              <Route
                path="/college-university-campus"
                element={<CollegeUniversityCampus />}
              />

              <Route
                path="/college-university-fees"
                element={<CollegeUniversityFees />}
              />

              <Route
                path="/manage-college-university"
                element={<ManageCollegeUniversity />}
              />
              <Route
                path="/add-course-adn-fees"
                element={<AddCourseAndFees />}
              />
              <Route
                path="/manage-course-and-fees"
                element={<ManageCourseAndFees />}
              />

              <Route path="/add-scholarship" element={<AddScholarship />} />

              <Route
                path="/manage-scholarship"
                element={<ManageScholarship />}
              />

              <Route path="/add-blog" element={<AddBlog />} />
              <Route path="/manage-blog" element={<ManageBlog />} />

              <Route path="/add-facility" element={<AddFacility />} />
              <Route path="/manage-facility" element={<ManageFacility />} />

              <Route path="/manage-gallery" element={<ManageGallery />} />
              {/* Property Type Route */}
              {/* <Route path="/add-property-type" element={<AddPropertyType />} />
            <Route
              path="/manage-property-type"
              element={<ManagePropertyType />}
            /> */}

              {/* BHK Route */}
              {/* <Route path="/add-bhk" element={<AddBhk />} />
            <Route path="/manage-bhk" element={<ManageBhk />} /> */}

              {/* Floor Route */}
              {/* <Route path="/add-floor" element={<AddFloor />} />
            <Route path="/manage-floor" element={<ManageFloor />} /> */}

              {/* Property Route */}
              {/* <Route path="/add-property" element={<AddProperty />} />
            <Route path="/manage-property" element={<ManageProperty />} /> */}

              {/* User Route */}
              {/* <Route path="/add-user" element={<AddUser />} /> */}
              {/* <Route path="/view-user-list" element={<UserList />} /> */}
              {/* <Route path="/manage-user" element={<ManageUser />} /> */}

              {/* Subscription Route */}
              {/* <Route path="/add-subscription" element={<AddSubscription />} />
            <Route
              path="/manage-subscription"
              element={<ManageSubscription />}
            /> */}

              {/* Banner Route */}
              {/* <Route path="/add-banner" element={<AddBanner />} /> */}
              {/* <Route path="/manage-subscription" element={<ManageSubscription />} /> */}

              {/* Advertisement Route */}
              {/* <Route path="/add-advertisement" element={<AddAdvertisement />} />
            <Route
              path="/manage-advertisement"
              element={<ManageAdvertisement />}
            /> */}

              {/* Facing Route */}
              {/* <Route path="/add-facing" element={<AddFacing />} />
            <Route path="/manage-facing" element={<ManageFacing />} /> */}

              {/* Desigation Route */}
              {/* <Route path="/add-designation" element={<AddDesignation />} />
            <Route path="/manage-designation" element={<ManageDesignation />} /> */}

              {/* Staff Route */}
              {/* <Route path="/add-staff" element={<AddStaff />} />
            <Route path="/manage-staff" element={<ManageStaff />} /> */}

              {/* Locality Route */}
              {/* <Route path="/add-locality" element={<AddLocality />} />
            <Route path="/manage-locality" element={<ManageLocality />} /> */}

              {/* Facing Route */}
              {/* <Route path="/add-apartment" element={<AddApartment />} />
            <Route path="/manage-apartment" element={<ManageApartment />} /> */}

              {/* Socity Route */}
              {/* <Route path="/add-society" element={<AddSociety />} />
            <Route path="/manage-society" element={<ManageSociety />} /> */}

              {/* Community Route */}
              {/* <Route path="/add-community" element={<AddCommunity />} />
            <Route path="/manage-community" element={<ManageCommunity />} /> */}

              {/* Inventory Route */}
              {/* <Route path="/add-inventory" element={<AddInventory />} />
            <Route path="/manage-inventory" element={<ManageInventory />} /> */}

              {/* Sales Route */}
              {/* <Route path="/sales" element={<Sales />} /> */}

              {/* Commission Route */}
              {/* <Route path="/add-commission" element={<AddCommission />} />
            <Route path="/manage-commission" element={<ManageCommission />} /> */}

              {/* Salary Route */}
              {/* <Route path="/add-salary" element={<AddSalary />} />
            <Route path="/manage-salary" element={<ManageSalary />} /> */}

              {/* Rent Route */}
              {/* <Route path="/add-rent" element={<AddRent />} />
            <Route path="/manage-rent" element={<ManageRent />} /> */}

              {/* Electricity Route */}
              {/* <Route path="/add-electricity" element={<AddElectricity />} />
            <Route path="/manage-electricity" element={<ManageElectricity />} /> */}

              {/* Telephone & Internet Route */}
              {/* <Route
              path="/add-telephone-n-internet"
              element={<AddTelephoneInternet />}
            />
            <Route
              path="/manage-telephone-n-internet"
              element={<ManageTelephoneInternet />}
            /> */}

              {/* Petrol Route */}
              {/* <Route path="/add-petrol" element={<AddPetrol />} />
            <Route path="/manage-petrol" element={<ManagePetrol />} /> */}

              {/* Miscellaneous Route */}
              {/* <Route path="/add-miscellaneous" element={<AddMiscellaneous />} />
            <Route
              path="/manage-miscellaneous"
              element={<ManageMiscellaneous />}
            /> */}

              {/* Report */}
              {/* <Route path="/expense-report" element={<ExpenseReport />} /> */}

              {/* Send Email */}
              {/* <Route path="/send-email-to-staff" element={<EmailToStaff />} />
            <Route
              path="/sent-email-to-staff"
              element={<SentEmailsToStaff />}
            /> */}

              {/* Hot Client */}
              {/* <Route path="/hot-clients" element={<HotClientList />} /> */}

              {/* Sales Pipeline */}
              {/* <Route path="/add-sales-pipeline" element={<AddSalesPipeline />} />
            <Route
              path="/manage-sales-pipeline"
              element={<ManageSalesPipeline />}
            /> */}

              {/* Menu Access */}
              {/* <Route path="/add-menu-access" element={<AddMenuAccess />} /> */}
              {/* <Route path="/manage-sales-pipeline" element={<ManageSalesPipeline />} /> */}
              {/* <Route path="/dynamic-table" element={<DynamicTable />} /> */}

              {/* Worksheet Route */}
              {/* <Route path="/work-sheet" element={<Worksheet />} /> */}

              {/* Blog Route */}
              {/* <Route path="/add-blog" element={<AddBlog />} />
            <Route path="/manage-blog" element={<ManageBlog />} /> */}
            </Route>
          </Route>
          <Route path="/login" element={<Login />} />
        </Routes>
      </BrowserRouter>
    </>
  );
};

export default App;
